/* The action button aligns with the close button */
.action-button {
    align-self: center;
    margin-right: 16px;
    transform: translateY(-1px);
}
